import React from 'react';
import NotificationsPage from './NotificationsPage';

// Backward-compatible route target. Keep one notification implementation so
// read/unread state and Firestore behavior cannot drift between two pages.
const NotificationCenter = () => <NotificationsPage />;

export default NotificationCenter;
